import A11yDialog from 'a11y-dialog';

const defaults = {
  mainSelector: 'main',
  languageSwitcherSelector: 'language-switcher'
};

class BrandHeader {
  constructor (element) {
    this.header = element;
    this.options = defaults;
    this.mainSection = document.getElementById(this.options.mainSelector);
    this.languageSwitcher = document.getElementById(this.options.languageSwitcherSelector);
  }

  addDialog () {
    if (this.languageSwitcher) {
      const languageSwitcherInit = new A11yDialog(this.languageSwitcher, this.mainSection); // eslint-disable-line no-unused-vars
    }
  }

  init () {
    this.addDialog();
  }
}
export default BrandHeader;
